angular.
module("dx.webapp.lists").
component("dxListPagination", {
	templateUrl: "tmpl/lists/list-pagination-component.html",
	controller: "DxListPaginationController",
	controllerAs: "vm",
	bindings: {
		currentPage: "=",
		itemCount: "<",
		itemsPerPage: "<",
	},
});
